import { useId, useState } from 'react';
import {
  ChevronIcon,
  ContentInner,
  ContentOuter,
  ContentPadding,
  Header,
  Label,
  Wrapper,
} from './AccordionLink.styles';
import type { AccordionLinkProps } from './AccordionLink.types';

export const AccordionLink = ({ label, children, defaultOpen = false }: AccordionLinkProps) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const contentId = useId();

  return (
    <Wrapper>
      <Header
        type="button"
        aria-expanded={isOpen}
        aria-controls={contentId}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <Label>{label}</Label>
        <ChevronIcon
          $isOpen={isOpen}
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M6 3L11 8L6 13"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </ChevronIcon>
      </Header>
      <ContentOuter id={contentId} role="region" $isOpen={isOpen}>
        <ContentInner $isOpen={isOpen}>
          <ContentPadding>{children}</ContentPadding>
        </ContentInner>
      </ContentOuter>
    </Wrapper>
  );
};
